import React from 'react';
import { Card, Typography } from '@mui/material';
import successImage from '../../../assets/registration/flexia-success_casino.png'
import { blueGrey } from '@mui/material/colors';
import { CONFIG_SETTINGS } from '../../../config';
import {makeStyles} from '@mui/styles'


/**
 * @module Layouts/Registration/views/SuccessView
 * @description The SuccessView function returns a React component that displays a success message with an image.
 * A React functional component called SuccessView is being returned. It renders a Card
 * component with a title, a message, and an image. The title and message are passed as props from a
 * configuration file. The image is imported from a file and displayed using an img tag. The component
 * also uses Material-UI styles to apply CSS styles to the elements.
 */

const SuccessView = () => {

    const classes = useStyles()

    let message = "Thanks! You'll be receiving an SMS in a few to download the App and Activate your account"

    return ( 
        <div className={classes.content}>
            <Card className={classes.card}>
                <Typography variant='h4' className={classes.title}>
                    {CONFIG_SETTINGS.SUCCESS_TITLE}
                </Typography>
                <div>
                    <Typography className={classes.message} variant='h6'>
                        {message}
                    </Typography>
                </div>
                <div className={classes.image_container}>
                    <img src={successImage} className={classes.image} alt=''/>
                </div>
            </Card>
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    content:{
        color:'white',
        margin:'0px auto',
        //marginTop:16,
        marginTop:0,
        width:'100%',
        maxWidth:650,
        textAlign:'center',
        boxSizing:'border-box',
        [theme.breakpoints.down('sm')]:{
            fontSize:16,
            maxWidth:'100%',
            padding:0,
            //background:'blue'
        }
    },
    card:{
        boxShadow:'none',
        //boxShadow:'7px 7px 20px rgb(0 0 0 / 10%)',
        //padding:16,
        borderRadius:20,
        marginTop:32,
        padding:'80px 32px',
        paddingTop:60,
        [theme.breakpoints.down('sm')]:{
            //fontSize:16,
            //maxWidth:'100%',
            padding:16,
            //background:'red'
        }

    },
    image_container:{
        width:350,
        margin:'auto',
        marginTop:40,
        [theme.breakpoints.down('sm')]:{
            width:250,
        }
    },
    image:{
        width:'100%'
    },
    title:{
        fontWeight:700,
        color:theme.palette.primary.main,
        [theme.breakpoints.down('sm')]:{
            fontWeight:700,
            fontSize:'1.750rem'
        }
        
    },
    message:{
        color:blueGrey[600],
        marginTop:8,
        [theme.breakpoints.down('sm')]:{
            fontSize:'1.125rem'
        }
    }

}))
 
export default SuccessView;